import type { ContextContent } from "$root/utils";
import type { StepMetadata } from "$root/components/MultiStepFormV2/MultiStepFormV2";
import type { SetterOrUpdater } from "@mdotm/shadcn/legacy/utils";
import type { QueryObserverResult } from "@tanstack/react-query";
import { createContext } from "react";
import type {
	EditPortfolioSaveHandlers,
	EditPortfolioV4Area,
	EditPortfolioV4StepName,
	EditPortfolioV4StepPayloadMap,
	SubmittersRef,
} from "./shared";

export type EditPortfolioV4Props = {
	saveHandlers: EditPortfolioSaveHandlers;
	submittersRef: SubmittersRef;
	area: EditPortfolioV4Area;
	currentStep: EditPortfolioV4StepName;
	setCurrentStep(stepName: EditPortfolioV4StepName): void;
	stepsMetadata: { [K in EditPortfolioV4StepName]: StepMetadata };
	setStepsMetadata: SetterOrUpdater<{
		[K in EditPortfolioV4StepName]: StepMetadata;
	}>;
	stepsData: EditPortfolioV4StepPayloadMap;
	/** Retrieve the latest stepsData */
	// eslint-disable-next-line react/no-unused-prop-types
	getStepsData(): EditPortfolioV4StepPayloadMap;
	getStepsMetadata(): { [K in EditPortfolioV4StepName]: StepMetadata };
	setStepsData(stepsData: EditPortfolioV4StepPayloadMap | null): void;
	refetch(): Promise<unknown>;
	refetchConfiguration(): Promise<unknown>;
	isDraftPresent: boolean;
};

export const EditPortfolioV4Context = createContext<
	| null
	| ({ canSubmit: boolean } & Omit<EditPortfolioV4Props, "stepsData"> & {
				refetch: () => Promise<QueryObserverResult<any>>;
			} & (
				| {
						stepsData: EditPortfolioV4Props["stepsData"];
						isLoading: false;
						isError: false;
				  }
				| {
						stepsData: EditPortfolioV4Props["stepsData"] | null;
						isLoading: true;
						isError: false;
				  }
				| {
						stepsData: null;
						isLoading: false;
						isError: true;
				  }
			))
>(null);

export type EditPortfolioV4ContextType = NonNullable<ContextContent<typeof EditPortfolioV4Context>>;
